// API helpers for course categories (backed by /api/admin/label-categories/).
// Adjust the import to match your shared axios instance, same as "./auth".
import apiClient from "./axios";

const BASE = "/api/admin/label-categories/";

export const adminGetCourseCategories = () => apiClient.get(BASE);
export const adminCreateCourseCategory = (data) => apiClient.post(BASE, data);
export const adminUpdateCourseCategory = (id, data) => apiClient.patch(`${BASE}${id}/`, data);
export const adminDeleteCourseCategory = (id) => apiClient.delete(`${BASE}${id}/`);